import primaryButton from '../../../../primary-button';

const dark = (params) => primaryButton.solidIcon.background.hover.dark(params);

export default dark;
